import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import economyReducers from "../reducers"

// The catalogue, loaded when the shop is opened rather than at bootstrap — most sessions never
// open it. Both tabs come back together because they are read together and the class prices need
// a balance that is current to grey out what cannot be afforded.
export const thunk = createAsyncThunk("economy/getShop", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("/shop/")
    return {
      credits: response.data.credits,
      races: response.data.races,
      cosmetics: response.data.cosmetics ?? [],
      packs: response.data.packs.map((pack) => ({
        id: pack.id,
        credits: pack.credits,
        bonus: pack.bonus,
        totalCredits: pack.total_credits,
        price: pack.price,
        label: pack.label,
      })),
      currency: response.data.currency,
      // Whether this server can take money at all. False hides the checkout rather than letting
      // the player commit to a purchase and fail at the click.
      purchasesEnabled: Boolean(response.data.purchases_enabled),
      shopLoaded: true,
    }
  } catch (error) {
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = economyReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
